/* MM FAQ — synchro topics ↔ category title + Q&A list */
(function () {
  function applyTopic(section, btn) {
    if (!section || !btn) return;
    var topicId = btn.getAttribute('data-topic-id') || '';
    var topicTitle = btn.getAttribute('data-topic-title') || '';
    var categoryTitle = btn.getAttribute('data-topic-category-title') || topicTitle;
    var topicSubtitle = btn.getAttribute('data-topic-subtitle') || '';
    var topicEyebrow = btn.getAttribute('data-topic-eyebrow') || '';

    section.querySelectorAll('[data-mm-faq-topic]').forEach(function (el) {
      var active = el === btn;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    var titleEl = section.querySelector('[data-mm-faq-cat-title]');
    var subEl = section.querySelector('[data-mm-faq-cat-sub]');
    var eyebrowEl = section.querySelector('[data-mm-faq-eyebrow]');
    if (titleEl) titleEl.textContent = categoryTitle;
    if (subEl) subEl.textContent = topicSubtitle;
    if (eyebrowEl && topicEyebrow) eyebrowEl.textContent = topicEyebrow;

    var questions = section.querySelectorAll('[data-mm-faq-question]');
    var firstVisible = null;
    questions.forEach(function (q) {
      var match = q.getAttribute('data-parent-topic') === topicId;
      q.hidden = !match;
      q.open = false;
      if (match && !firstVisible) firstVisible = q;
    });
    if (firstVisible) firstVisible.open = true;
  }

  function init(section, firstActive) {
    if (!section || section.dataset.mmFaqReady === '1') return;
    section.dataset.mmFaqReady = '1';

    section.querySelectorAll('[data-mm-faq-topic]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        applyTopic(section, btn);
      });
    });

    var initialBtn = firstActive || section.querySelector('[data-mm-faq-topic].is-active') || section.querySelector('[data-mm-faq-topic]');
    if (initialBtn) applyTopic(section, initialBtn);
  }

  window.MMFaqInit = init;

  function bootAll() {
    document.querySelectorAll('[data-mm-faq]').forEach(function (section) {
      init(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target && e.target.querySelector('[data-mm-faq]');
    if (section) init(section);
  });
})();
